import React from 'react'
import styles from './shared-skeleton-entry.styles'
import injectSheet from 'react-jss'
import { TableRow, Cell } from 'pobble-components/dist/table'
import Bone from 'pobble-components/dist/bone'

const SharedSkeletonEntry = ({ classes, titleWidth }) => (
  <TableRow>
    <Cell center>
      <Bone className={classes.checkbox} />
    </Cell>
    <Cell>
      <Bone className={classes.received} />
    </Cell>
    <Cell>
      <Bone className={classes.from} />
    </Cell>
    <Cell>
      <Bone style={{ width: titleWidth + 'px' }} />
    </Cell>
    <Cell center>
      <Bone className={classes.lo} />
    </Cell>
    <Cell right>
      <Bone className={classes.context} />
    </Cell>
  </TableRow>
)

export default injectSheet(styles)(SharedSkeletonEntry)
